<template>
  <div v-if="supporter" class="section">
    <div class="head">
      <div class="title">
        <h3>Supporter Details</h3>
        <p class="sub-title">
          Created: {{ supporter.createdAt | date('dd-MM-yyyy HH:mm') }} - Last Updated:
          {{ supporter.updatedAt | date('dd-MM-yyyy HH:mm') }}
        </p>
      </div>
    </div>

    <div class="body halved">
      <!-- General Information -->
      <div class="details">
        <div class="intro">
          <h4>General Information</h4>
          <a class="edit" v-on:click="open(modalNames.EDIT_DETAILS)" v-if="canEdit">Edit Details</a>
        </div>
        <dl class="fields desc">
          <div class="field">
            <dt class="label">Title</dt>
            <dd class="value">{{ supporter.title || ' ' }}</dd>
          </div>
          <div class="field">
            <dt class="label">First Name</dt>
            <dd class="value">{{ supporter.firstName }}</dd>
          </div>
          <div class="field">
            <dt class="label">Last Name</dt>
            <dd class="value">{{ supporter.lastName }}</dd>
          </div>
        </dl>
      </div>

      <!-- Identifiers -->
      <div class="details">
        <div class="intro">
          <h4>Identifiers</h4>
        </div>
        <dl class="fields desc">
          <div class="field">
            <dt class="label">Pandata ID</dt>
            <dd class="value">{{ supporter.id }}</dd>
          </div>
          <div class="field">
            <dt class="label">SSO ID</dt>
            <dd class="value">{{ supporter.ssoId }}</dd>
          </div>
          <div class="field">
            <dt class="label">Raiser's Edge ID</dt>
            <dd class="value">{{ supporter.reConstituentId }}</dd>
          </div>
          <div class="field">
            <dt class="label">Marketo ID</dt>
            <dd class="value">{{ supporter.marketoLeadId }}</dd>
          </div>
        </dl>
      </div>
    </div>

    <!-- Contacts -->
    <div class="body halved">
      <SupporterViewPhones
        :canEdit="canEdit"
        :contacts="phones"
        @addContact="addContact"
        @editContact="editContact"
      ></SupporterViewPhones>
      <SupporterViewEmails
        :canEdit="canEdit"
        :contacts="emails"
        @addContact="addContact"
        @editContact="editContact"
      ></SupporterViewEmails>
    </div>

    <!-- Addresses -->
    <div class="body">
      <SupporterViewAddresses
        :canEdit="canEdit"
        :supporter="supporter"
        :addresses="supporter.addresses"
      ></SupporterViewAddresses>
    </div>

    <!-- Popups -->
    <SupporterEditDetails :supporter="supporter" v-if="isOpen(modalNames.EDIT_DETAILS)"></SupporterEditDetails>
    <!-- <SupporterAddContact
      :supporter="supporter"
      :canEdit="canEdit"
      :type="type"
      v-if="isOpen(modalNames.ADD_CONTACT)"
    ></SupporterAddContact>
    <SupporterEditContact
      :supporter="supporter"
      :canEdit="canEdit"
      :type="type"
      :contact="contact"
      v-if="contact && isOpen(modalNames.EDIT_CONTACT)"
    ></SupporterEditContact> -->
  </div>
</template>

<script>
import SupporterEditDetails from './SupporterEditDetails.vue';
// import SupporterEditContact from './SupporterEditContact.vue';
// import SupporterAddContact from './SupporterAddContact.vue';
import { MODULE, PERMISSION } from '@/helpers/security';
import { MODAL_NAME } from '../../stores/supporters';
import SupporterViewAddresses from './SupporterViewAddresses.vue';
import SupporterViewEmails from './SupporterViewEmails.vue';
import SupporterViewPhones from './SupporterViewPhones.vue';

export default {
  name: 'SupporterDetails',
  components: {
    SupporterEditDetails,
    // SupporterAddContact,
    // SupporterEditContact,
    SupporterViewEmails,
    SupporterViewPhones,
    SupporterViewAddresses,
  },

  data() {
    return {
      address: null,
      type: null,
      contact: null,
    };
  },
  props: {
    supporter: Object,
  },
  computed: {
    canEdit() {
      return this.$store.getters['auth/hasAccess'](MODULE.SUPPORTER, [PERMISSION.EDIT]);
    },
    modalNames() {
      return MODAL_NAME;
    },
    emails() {
      return this.supporter.contacts.filter((contact) => contact.type === 'email');
    },
    phones() {
      return this.supporter.contacts.filter((contact) => contact.type === 'phone');
    },
  },

  methods: {
    isOpen(modalName) {
      return this.$store.getters['supporters/isOpen'](modalName);
    },
    open(modalName) {
      this.$store.commit('supporters/open', modalName);
    },
    addContact(type) {
      this.type = type;
      this.open(MODAL_NAME.ADD_CONTACT);
    },
    editContact({ type, contact }) {
      this.type = type;
      this.contact = contact;
      this.open(MODAL_NAME.EDIT_CONTACT);
    },
  },
};
</script>

<style lang="scss" scoped></style>
